import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";

import Pricing from "../pages/Pricing";
import useAuth from "../../hooks/useAuth";
import axios from "../../utils/axios";
import config from "../../config";

const stripePromise = loadStripe(config.STRIPE_ID || "", {
  locale: "sl",
});

const Plan = ({ subscription, ...props }: any) => {
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col className="text-center">
            <h5>
              Naročeni ste na mesečni plan{" "}
              <b>{subscription.plan.metadata.planName}</b>.<br />
              <br />
              Naročnina je veljavna do{" "}
              {moment(subscription.current_period_end * 1000).format(
                "DD.MM.YYYY"
              )}
              .
            </h5>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const Settings = () => {
  const [company, setCompany] = useState({
    subscribed: undefined,
    subscription: {
      plan: undefined,
    },
  });
  const [refreshData, setRefreshData] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      return;
    }
    axios.get("/companies/" + user.companyId).then((data: any) => {
      setCompany(data.data.company);
    });
  }, [user, refreshData]);

  return (
    <React.Fragment>
      <Helmet title="Nastavitve" />
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Nastavitve naročnine</h1>

        <Row>
          <Col>
            <Elements stripe={stripePromise}>
              <Card>
                <Card.Header>
                  <Card.Title className="mb-0">Naročnina</Card.Title>
                </Card.Header>
                <Card.Body>
                  {company.subscribed ? (
                    <>
                      <Pricing
                        subscription={company.subscription}
                        refreshData={(val: boolean) => setRefreshData(val)}
                      />
                      <hr />
                      <Plan subscription={company.subscription} />
                    </>
                  ) : company.subscribed === undefined ? (
                    <div className="text-center">
                      <Spinner
                        className="text-center"
                        animation="border"
                        role="status"
                      >
                        <span className="visually-hidden">Nalagam...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <Pricing
                      refreshData={(val: boolean) => setRefreshData(val)}
                    />
                  )}
                </Card.Body>
              </Card>
            </Elements>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Settings;
